import { Alert, AlertContext, Builder_, Checkbox_, Confirmation_, device, Dropdown_, Filled_Edit, Form, FormBox, FormBoxSelection, FormBoxTitle, Grey_, Grey_Link, Input_, LimitCharacters, Main_, Main_Plain, Red_, Slider_, Textarea_ } from 'monica-alexandria'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components';
import b from "../../../services/api/Boards";
import l from "../../../services/api/Landings";
import { alertMessage } from '../../../utils/messagesAlerts';
import Crm_Lead_Notes from './Crm_Lead_Notes';
import { useClickOutside } from '../../../hooks/useClickOutside';
import Lead_Editor_Layout from './Lead_Editor_Layout';
import Input_Phone from './Input_Phone';
import store from '../../../redux/store';
import { CALL_FOLLOW_UP_FIELD, formatCallFollowUp, readCallFollowUp, toDateTimeLocalValue } from '../callFollowUp';
import { Calendar_Field } from '../../../components/form/Calendar_Field';
import { readLeadCustomFields, getLeadCustomFieldsError, leadCustomFieldPayload } from '../customFieldAnswers';
import LeadCustomFields from './LeadCustomFields';

const CALL_OUTCOME_LABELS = {
  connected: "Connected",
  no_answer: "No answer",
  voicemail: "Left voicemail",
  wrong_number: "Wrong number",
};

const CALL_OUTCOME_COLORS = {
  connected: "var(--main)",
  completed: "var(--main)",
  no_answer: "#c77618",
  voicemail: "#6f67c7",
  wrong_number: "#c95252",
  cancelled: "#c95252",
};

const CrmEditLead = styled.div` 
  select{
     background: ${(p) => p.bg || p.theme.mid};

     option{
      background: ${p=> p.theme.mid};
     }
  }
`


const EditFormBox = styled(FormBox)`
  box-shadow: ${p => p.theme.in};

  .Builder{
    grid-template-columns: 20% 80%;
  }
`
const LeadActions = styled.div`
  display: flex;
  align-items: stretch;
  gap: 0;
  width: 100%;
  margin-bottom: 2rem;
  border-bottom: 1px solid color-mix(in srgb, ${(p) => p.theme.color} 12%, transparent);

  .more-action {
    margin-left: auto;
    align-self: center;
  }
  .leadView{
    display: none;
  }
  @media ${device.md}{
    .leadView{
      display: block;
    }
  }
`

const LeadTab = styled(Main_Plain)`
  position: relative;
  min-height: 4.8rem;
  padding: 0 2.4rem !important;
  border: 0 !important;
  border-radius: 0 !important;
  background: transparent !important;

  span, h5, p {
    color: ${(p) => p.active ? "var(--main)" : p.theme.color} !important;
  }

  svg {
    fill: ${(p) => p.active ? "var(--main)" : p.theme.color} !important;
  }

  &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px;
    height: 2px;
    background: ${(p) => p.active ? "var(--main)" : "transparent"};
    transition: background 0.2s ease;
  }

  &:hover {
    background: transparent !important;

    span, h5, p {
      color: var(--main) !important;
    }
  }
`

const CrmFormBoxSelection= styled(FormBoxSelection)`
    margin-bottom: ${p=> p.noMargin ? 0 : '2rem'};
`
 
const LeadActionsWrapper = styled.div`
  position: relative;
  width: 100%;
  
`

const MoreActionsMenu = styled.div`
  position: absolute;
  top: 4.5rem;
  right: 0;
  z-index: 20;
  min-width: ${(p) => p.moveOptions ? "32rem" : "15rem"};
  padding: ${(p) => p.moveOptions ? "1.5rem" : "0.6rem"};
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  background: ${(p) => p.theme.mid};
  border: 1px solid ${(p) => p.theme.low};
  border-radius: var(--smallRadius);
  box-shadow: ${(p) => p.theme.out};
`;

const MoreActionsControl = styled.div`
  position: relative;
  margin-left: auto;
  align-self: center;
`;

const ArchivedLabel = styled.div`
  display: flex;
  align-items: center;
  justify-self: right;
  background:rgba(45, 96, 103, 0.5);
  padding: var(--smallPads);
  border-radius: var(--smallRadius);
  border: 1px solid var(--main);
  
  `
const EditFormBoxTitle = styled(FormBoxTitle)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const MoveLeadWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 1rem;
  
`

const MoveLeadOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const MoveLeadModalTitle = styled.h5`
  margin: 0;
`;

const MoveLeadModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
`;

const CallFollowUpBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
`;

const NativeDateTimeInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  border: none;
  border-radius: var(--smallRadius);
  background: ${(p) => p.theme.background};
  color: ${(p) => p.theme.color};
  box-shadow: ${(p) => p.theme.in};
  padding: var(--normalPads);
  font-size: var(--normalText);

  &:focus {
    outline: 0;
    box-shadow: ${(p) => p.theme.inFocus};
  }
`;

const CallFollowUpActions = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
`;

const CallActionsControl = styled.div`
  position: relative;
`;

const CallActionsMenu = styled(MoreActionsMenu)`
  top: calc(100% + 0.8rem);
`;

const CallFormFooter = styled(CallFollowUpActions)`
  margin-top: 0.4rem;
  padding-top: 1.6rem;
  border-top: 1px solid color-mix(in srgb, ${(p) => p.theme.color} 12%, transparent);
`;

const CallFormError = styled.p`
  margin: -0.6rem 0 0;
  color: var(--error, #d85858);
`;

const OutcomeOptions = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.8rem;

  @media ${device.md} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

const OutcomeOption = styled.button`
  min-height: 4.4rem;
  padding: 0.8rem 1rem;
  border: 1px solid ${(p) => p.selected ? "var(--main)" : p.theme.low};
  border-radius: var(--smallRadius);
  background: ${(p) => p.selected
    ? `color-mix(in srgb, var(--main) 12%, ${p.theme.background})`
    : p.theme.background};
  color: ${(p) => p.selected ? "var(--main)" : p.theme.color};
  font-family: fontMedium, sans-serif;
  font-size: 1.4rem;
  font-weight: ${(p) => p.selected ? 700 : 500};
  cursor: pointer;
`;

const ScheduleAnotherBox = styled.div`
  padding: 1.4rem;
  border-radius: var(--smallRadius);
  background: ${(p) => p.theme.mid};
`;

const CallFollowUpSummary = styled(FormBox)`
  box-shadow: ${p => p.theme.in};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;

  > div:first-child { min-width: 0; }
  p { white-space: normal; overflow-wrap: anywhere; }
`;

const NextCallCard = styled.div`
  position: relative;
  overflow: visible;
  border: 1px solid ${(p) => p.theme.mid};
  border-radius: var(--normalRadius);
  background: ${(p) => p.theme.low};
  box-shadow: ${(p) => p.theme.out};
`;

const NextCallHeader = styled.div`
  padding: var(--normalPads);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  border-bottom: 1px solid ${(p) => p.theme.low};
  border-radius: var(--normalRadius) var(--normalRadius) 0 0;
  background: color-mix(in srgb, var(--main) 7%, ${(p) => p.theme.mid});

  h5 {
    margin: 0;
    color: var(--main);
    text-transform: uppercase;
    letter-spacing: 0.06em;
    font-size: 1.4rem;
  }

  p {
    margin: 0;
    opacity: 0.75;
    overflow-wrap: anywhere;
  }
`;

const NextCallBody = styled.div`
  padding: 1.8rem;
`;

const NextCallSchedule = styled.div`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 1.8rem;

  @media ${device.md} {
    grid-template-columns: auto minmax(0, 1fr);

    ${CallFollowUpActions} {
      grid-column: 1 / -1;
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr)) auto;
      width: 100%;
      gap: 0.8rem;
      flex-wrap: nowrap;

      > * {
        min-width: 0;
      }

      > *:not(:last-child) {
        width: 100%;
        justify-content: center;
      }

      ${CallActionsControl} {
        justify-self: end;
      }
    }
  }
`;

const CallDateTile = styled.div`
  width: 6rem;
  overflow: hidden;
  flex: 0 0 auto;
  text-align: center;
  border: 1px solid ${(p) => p.theme.low};
  border-radius: var(--smallRadius);
  background: ${(p) => p.theme.background};
  color: ${(p) => p.theme.color};

  span {
    display: block;
    padding: 0.35rem;
    background: ${(p) => p.theme.mid};
    font-weight: 700;
    text-transform: uppercase;
  }

  strong {
    display: block;
    padding: 0.7rem 0;
    font-size: 2.2rem;
  }
`;

const CallScheduleDetails = styled.div`
  min-width: 0;

  h3 {
    margin: 0 0 0.2rem;
  }

  p {
    margin: 0;
    opacity: 0.72;
    white-space: normal;
  }

  a {
    display: inline-block;
    margin-top: 0.75rem;
    color: ${(p) => p.theme.color};
    font-weight: 600;
    text-decoration: none;
  }
`;

const CallAgenda = styled.div`
  margin-top: 1.6rem;
  padding: 1.4rem;
  border-radius: var(--smallRadius);
  background: ${(p) => p.theme.background};

  h6 {
    margin: 0 0 0.5rem;
    opacity: 0.65;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  p {
    margin: 0;
    white-space: normal;
    overflow-wrap: anywhere;
  }
`;

const CompletedCallSummary = styled(CallFollowUpSummary)`
  border-left: 4px solid var(--main);

  h4 {
    color: var(--main);
  }
`;

const FollowUpHistory = styled.div`
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid color-mix(in srgb, ${(p) => p.theme.color} 12%, transparent);
`;

const FollowUpHistoryRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  margin-top: 1rem;
  padding: 1.2rem 1.4rem;
  border: 1px solid ${(p) => p.theme.low};
  border-radius: var(--smallRadius);
  background: ${(p) => p.theme.mid};

  h6 { margin-bottom: 0.35rem; }
  p { opacity: 0.75; white-space: normal; }

  @media ${device.md} {
    flex-direction: column;
    gap: 0.6rem;
  }
`;

const CallOutcome = styled.span`
  --call-outcome-color: ${(p) => CALL_OUTCOME_COLORS[p.outcome] || "var(--main)"};
  display: inline-flex;
  margin-bottom: 0.5rem;
  padding: var(--smallPads);
  border-radius: var(--smallRadius);
  background: color-mix(in srgb, var(--call-outcome-color) 15%, ${(p) => p.theme.background});

  p {
    color: var(--call-outcome-color);
    font-weight: 700;
  }
`;

export default function Crm_Edit_Lead(props) {

    const {t} = useTranslation();
    const currentUser = store.getState()?.user?.user || {};
    const currentUserId = currentUser?.sub || "";
    const currentUserEmail = typeof currentUser?.email === "string"
      ? currentUser.email
      : currentUser?.email?.email || "";
    const currentUserName = [currentUser?.firstname, currentUser?.lastname].filter(Boolean).join(" ").trim() || currentUserEmail;
    const [editingField, setEditingField] = useState(false)
    const isWon = props.activeColumnId === 'won'
    const [selectedQuest, setSelectedQuest]= useState({id:props.editingLead?.landingId,data:''})
    const [confirmMove,setConfirmMove] = useState(false)
    const [moveModalOpen, setMoveModalOpen] = useState(false)
    const [moreMenuOpen, setMoreMenuOpen] = useState(false)
    const [callActionsMenuOpen, setCallActionsMenuOpen] = useState(false)
    const [activeTab, setActiveTab] = useState(props.initialTab || "details")
    const moreMenuRef = useRef(null);
    const callActionsMenuRef = useRef(null);
    const {alerts, setAlerts} = useContext(AlertContext);
    const [localNotes, setLocalNotes] = useState(
      Array.isArray(props.editingLead?.Notes) ? props.editingLead.Notes : []
    );
    const localNotesRef = useRef(
      Array.isArray(props.editingLead?.Notes) ? props.editingLead.Notes : []
    );
    const [text, setText] = useState("");
    const [showCallScheduler, setShowCallScheduler] = useState(false);
    const [useNativeDatePicker, setUseNativeDatePicker] = useState(false);
    const [callDraft, setCallDraft] = useState({ scheduledAt: "", assignedTo: null, note: "" });
    const [callFormError, setCallFormError] = useState("");
    const [showCallOutcomeForm, setShowCallOutcomeForm] = useState(false);
    const [callOutcomeDraft, setCallOutcomeDraft] = useState({
      outcome: "",
      note: "",
      scheduleAnother: false,
      scheduledAt: "",
    });
    const [callOutcomeError, setCallOutcomeError] = useState("");
    const [savingCall, setSavingCall] = useState(false);
    const [showPastCalls, setShowPastCalls] = useState(false);
    const callFollowUp = readCallFollowUp(props.editingLead) || {};
    const scheduleUsers = (props.scheduleUsers || []).filter((user, index, users) => {
      const key = String(user?.userId || user?.id || user?.email || "").toLowerCase();
      return key && users.findIndex((candidate) => String(candidate?.userId || candidate?.id || candidate?.email || "").toLowerCase() === key) === index;
    });

    useClickOutside(moreMenuRef, () => {
      setMoreMenuOpen(false);
      setMoveModalOpen(false);
    }, moreMenuOpen);

    useClickOutside(callActionsMenuRef, () => {
      setCallActionsMenuOpen(false);
    }, callActionsMenuOpen);

    useEffect(() => {
      const media = window.matchMedia(device.md.replace("@media ", ""));
      const updatePicker = () => setUseNativeDatePicker(media.matches);
      updatePicker();
      media.addEventListener("change", updatePicker);
      return () => media.removeEventListener("change", updatePicker);
    }, []);

    useEffect(() => {
      const nextNotes = Array.isArray(props.editingLead?.Notes)
        ? props.editingLead.Notes
        : [];
      localNotesRef.current = nextNotes;
      setLocalNotes(nextNotes);
      setText("");
      setShowCallScheduler(false);
      setCallDraft({ scheduledAt: "", assignedTo: null, note: "" });
      setCallFormError("");
      setShowCallOutcomeForm(false);
      setCallOutcomeDraft({ outcome: "", note: "", scheduleAnother: false, scheduledAt: "" });
      setCallOutcomeError("");
      setSavingCall(false);
      setShowPastCalls(false);
      setCallActionsMenuOpen(false);
      setActiveTab(props.initialTab || "details");
    }, [props.editingLead?._id]);

    const name = props?.editingLead?.FullName || [
      props?.editingLead?.Name,
      props?.editingLead?.Surname
    ].filter(Boolean).join(" ") 
    || "";


    const isDefined = (field) =>{
      return Object.prototype.hasOwnProperty.call(props.editingLead || {}, field)
    }

   const updateLeadField = (field, value) => {
      console.log('field', field, value);
      props.setEditingLead({ ...props.editingLead, [field]: value })
    }

    const readFollowUpActor = () => ({
      userId: currentUserId,
      email: currentUserEmail,
      name: currentUserName,
    });

    const appendFollowUpHistory = (entry) => [
      ...(Array.isArray(callFollowUp.history) ? callFollowUp.history : []),
      { ...entry, at: new Date().toISOString(), by: readFollowUpActor() },
    ].slice(-50);

    const getDefaultCallAssignee = () => {
      const fallbackAssignee = scheduleUsers.find((user) =>
        String(user?.userId || "") === String(currentUserId || "")
        || String(user?.email || "").toLowerCase() === String(currentUserEmail || "").toLowerCase()
      ) || scheduleUsers[0];

      return fallbackAssignee ? {
          userId: fallbackAssignee.userId || fallbackAssignee.id || "",
          email: fallbackAssignee.email || "",
          name: fallbackAssignee.name || [fallbackAssignee.firstname, fallbackAssignee.lastname].filter(Boolean).join(" "),
        } : readFollowUpActor();
    };

    const openCallScheduler = () => {
      const isExistingCall = callFollowUp.status === "scheduled" && callFollowUp.scheduledAt;
      setCallDraft({
        scheduledAt: isExistingCall ? callFollowUp.scheduledAt : "",
        assignedTo: isExistingCall && callFollowUp.assignedTo
          ? callFollowUp.assignedTo
          : getDefaultCallAssignee(),
        note: isExistingCall ? callFollowUp.note || "" : "",
      });
      setCallFormError("");
      setCallActionsMenuOpen(false);
      setShowCallOutcomeForm(false);
      setShowCallScheduler(true);
    };

    const persistCallFollowUp = async (nextFollowUp) => {
      setSavingCall(true);
      try {
        const nextLead = {
          ...props.editingLead,
          Notes: localNotesRef.current,
          [CALL_FOLLOW_UP_FIELD]: {
            ...nextFollowUp,
            updatedAt: new Date().toISOString(),
            updatedBy: currentUserId || currentUserEmail,
          },
        };
        const savedLead = await props.saveLead(nextLead, { closeEditor: false });

        if (!savedLead) {
          setCallFormError(t("Could not save the call. Please try again."));
          return false;
        }

        props.onLeadPatched?.(savedLead);
        return true;
      } catch (error) {
        console.error("persistCallFollowUp failed:", error);
        setCallFormError(t("Could not save the call. Please try again."));
        return false;
      } finally {
        setSavingCall(false);
      }
    };

    const scheduleCallFollowUp = async () => {
      const date = callDraft.scheduledAt ? new Date(callDraft.scheduledAt) : null;
      if (!date || Number.isNaN(date.getTime())) {
        setCallFormError(t("Choose a date and time"));
        return;
      }
      if (date.getTime() <= Date.now()) {
        setCallFormError(t("Choose a future date and time"));
        return;
      }

      const wasScheduled = callFollowUp.status === "scheduled" && callFollowUp.scheduledAt;
      const dateChanged = !wasScheduled || new Date(callFollowUp.scheduledAt).getTime() !== date.getTime();
      const nextHistory = Array.isArray(callFollowUp.history) ? [...callFollowUp.history] : [];
      if (dateChanged) {
        nextHistory.push({
          type: wasScheduled ? "rescheduled" : "scheduled",
          fromScheduledAt: wasScheduled ? callFollowUp.scheduledAt : "",
          toScheduledAt: date.toISOString(),
          at: new Date().toISOString(),
          by: readFollowUpActor(),
        });
      }

      const saved = await persistCallFollowUp({
        ...callFollowUp,
        scheduledAt: date.toISOString(),
        status: "scheduled",
        completedAt: "",
        completedBy: "",
        assignedTo: callDraft.assignedTo || getDefaultCallAssignee(),
        note: String(callDraft.note || "").trim(),
        history: nextHistory.slice(-50),
      });

      if (saved) {
        setCallFormError("");
        setShowCallScheduler(false);
        alertMessage(
          alerts,
          setAlerts,
          t(wasScheduled ? "Call updated" : "Call scheduled"),
          "Success"
        );
      }
    };

    const getSuggestedNextCallDate = () => {
      const now = new Date();
      const originalDate = callFollowUp.scheduledAt ? new Date(callFollowUp.scheduledAt) : null;
      const nextDate = originalDate && !Number.isNaN(originalDate.getTime()) && originalDate > now
        ? new Date(originalDate)
        : new Date(now);
      nextDate.setDate(nextDate.getDate() + 1);
      nextDate.setSeconds(0, 0);
      nextDate.setMinutes(Math.ceil(nextDate.getMinutes() / 15) * 15);
      return nextDate.toISOString();
    };

    const openCallOutcomeForm = () => {
      setCallOutcomeDraft({
        outcome: "",
        note: "",
        scheduleAnother: false,
        scheduledAt: "",
      });
      setCallOutcomeError("");
      setCallActionsMenuOpen(false);
      setShowCallScheduler(false);
      setShowCallOutcomeForm(true);
    };

    const selectCallOutcome = (outcome) => {
      const shouldSuggestAnotherCall = ["no_answer", "voicemail"].includes(outcome);
      setCallOutcomeDraft((draft) => ({
        ...draft,
        outcome,
        scheduleAnother: shouldSuggestAnotherCall,
        scheduledAt: shouldSuggestAnotherCall
          ? draft.scheduledAt || getSuggestedNextCallDate()
          : "",
      }));
      setCallOutcomeError("");
    };

    const saveCallOutcome = async () => {
      if (!callOutcomeDraft.outcome) {
        setCallOutcomeError(t("Choose a call outcome"));
        return;
      }

      const nextCallDate = callOutcomeDraft.scheduleAnother && callOutcomeDraft.scheduledAt
        ? new Date(callOutcomeDraft.scheduledAt)
        : null;
      if (callOutcomeDraft.scheduleAnother && (!nextCallDate || Number.isNaN(nextCallDate.getTime()))) {
        setCallOutcomeError(t("Choose when to call again"));
        return;
      }
      if (nextCallDate && nextCallDate.getTime() <= Date.now()) {
        setCallOutcomeError(t("Choose a future date and time"));
        return;
      }

      const completedAt = new Date().toISOString();
      const completedEvent = {
        type: "completed",
        outcome: callOutcomeDraft.outcome,
        scheduledAt: callFollowUp.scheduledAt,
        note: String(callOutcomeDraft.note || "").trim(),
        at: completedAt,
        by: readFollowUpActor(),
      };
      const history = [
        ...(Array.isArray(callFollowUp.history) ? callFollowUp.history : []),
        completedEvent,
      ];

      if (nextCallDate) {
        history.push({
          type: "scheduled",
          fromOutcome: callOutcomeDraft.outcome,
          toScheduledAt: nextCallDate.toISOString(),
          at: completedAt,
          by: readFollowUpActor(),
        });
      }

      const saved = await persistCallFollowUp({
        ...callFollowUp,
        status: nextCallDate ? "scheduled" : "completed",
        scheduledAt: nextCallDate ? nextCallDate.toISOString() : callFollowUp.scheduledAt,
        completedAt: nextCallDate ? "" : completedAt,
        completedBy: nextCallDate ? "" : currentUserId || currentUserEmail,
        outcome: nextCallDate ? "" : callOutcomeDraft.outcome,
        outcomeNote: nextCallDate ? "" : String(callOutcomeDraft.note || "").trim(),
        assignedTo: callFollowUp.assignedTo || getDefaultCallAssignee(),
        history: history.slice(-50),
      });

      if (saved) {
        setShowCallOutcomeForm(false);
        setCallOutcomeError("");
      }
    };

    const cancelCallFollowUp = async () => {
      const saved = await persistCallFollowUp({
        ...callFollowUp,
        status: "cancelled",
        scheduledAt: "",
        history: appendFollowUpHistory({
          type: "cancelled",
          scheduledAt: callFollowUp.scheduledAt,
          note: callFollowUp.note || "",
        }),
      });
      if (saved) setShowCallScheduler(false);
    };

    const customFieldRows = readLeadCustomFields(props.editingLead?.CustomField);
    const [customFieldError, setCustomFieldError] = useState('');

    const updateCustomFieldRow = (index, key, value) => {
      const updatedFields = [...customFieldRows];
      updatedFields[index] = {
        ...updatedFields[index],
        [key]: value
      };
      props.setEditingLead({ 
        ...props.editingLead, 
        CustomField: updatedFields 
      });
  };
    
  const getQuestLabel = (quest) => {
    if (!quest) return "";

    if (quest?.name) return quest.name;

    return `${quest?.questionnaires?.[0]?.answer || ""} ${
      LimitCharacters(quest?.questionnaires?.[1]?.answer || "", 15)
    } | ${LimitCharacters(quest?.Meta?.facebookPageName || "", 15)}`;
  };


  const handleSelectedQuest = (qId) => {

    const q= props.quests?.find(q => q._id === qId)
    setSelectedQuest({id:qId, data:q})
  }

  const handleArchive = async () => {
    try {
      const res = await l.archiveLead(props.editingLead._id);

      // remove from board immediately
      props.removeLeadFromBoard(props.editingLead._id);

      alertMessage(alerts, setAlerts, t("Lead archived"), "Success");
      props.onClose();
    } catch (err) {
      alertMessage(alerts, setAlerts, t("Failed to archive lead"), "Error");
    }
  };


  const updateNotesState = (updater) => {
    const nextNotes =
      typeof updater === "function"
        ? updater(localNotesRef.current || [])
        : updater;

    localNotesRef.current = nextNotes;
    setLocalNotes(nextNotes);

    const nextLead = {
      ...props.editingLead,
      Notes: nextNotes,
    };

    props.setEditingLead((prevLead) => ({
      ...prevLead,
      Notes: nextNotes,
    }));
    props.onLeadPatched?.(nextLead);
  };

  const handleAddNote = async () => {
      const trimmed = text.trim();
      if (!trimmed) return;

      const tempId = `temp_${Date.now()}`;

      const optimisticNote = {
        _id: tempId, // temporary id
        text: trimmed,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        createdBy: currentUserId || null,
        createdByName: currentUserName,
        createdByEmail: currentUserEmail,
      };

      // 1️⃣ Optimistic update → update editingLead
      updateNotesState((prevNotes) => [optimisticNote, ...(prevNotes || [])]);

      setText("");

      try {
        // 2️⃣ Backend call
        const res = await l.addNote(props.editingLead._id, trimmed);
        const savedNote = res?.data?.note || res?.data;
        if (!savedNote || typeof savedNote !== "object") {
          throw new Error("Invalid note response");
        }

        // 3️⃣ Replace temp note with backend note
        //useless
        updateNotesState((prevNotes) =>
          (prevNotes || []).map((note) =>
            note._id === tempId || note._tempId === tempId ? savedNote : note
          )
        );
      } catch (err) {
        // 4️⃣ Rollback on error
        updateNotesState((prevNotes) =>
          (prevNotes || []).filter(
            (note) => note._id !== tempId && note._tempId !== tempId
          )
        );
      }
};



  const moveLead = () => {
    b.moveLeadToQuest({
      leadId: props.editingLead._id,
      fromQuestId: props.editingLead?.landingId,
      toQuestId: selectedQuest?.id
     
      }).then(res => {
        if(res.data.code === 'B2001'){
          alertMessage(alerts, setAlerts, t('Lead moved successfully'), 'Success')
          props.removeLeadFromBoard(props.editingLead._id)
        }
        else {
          alertMessage(alerts, setAlerts, t('There was an error'), 'Error')
        }

        setConfirmMove(false)
        props.onClose()        
      
     })
  }  

  const archivedLabel = (   
    <ArchivedLabel>
      <p>{t("Archived at " + new Date(props.editingLead.archivedAt).toLocaleDateString())}</p> 
    </ArchivedLabel>
  )

  const headerActions = (
      <LeadActionsWrapper>
        <LeadActions>
          <LeadTab text={t('Details')} active={activeTab === "details"} onClick={() => setActiveTab("details")} />
          <LeadTab className="leadView" text={t('Notes')} active={activeTab === "notes"} onClick={() => setActiveTab("notes")} />
          <LeadTab
            text={t("Calls")}
            active={activeTab === "schedule"}
            onClick={() => setActiveTab("schedule")}
          />
          <MoreActionsControl ref={moreMenuRef}>
            <Grey_ iconRight="More" className="more-action" onClick={() => {
              setMoreMenuOpen((open) => {
                if (open) setMoveModalOpen(false);
                return !open;
              });
            }} />
            {moreMenuOpen ? (
              <MoreActionsMenu moveOptions={moveModalOpen}>
            {moveModalOpen ? (
              <MoveLeadOptions>
                <Grey_Link iconLeft="Back" text={t("Back")} noPadding onClick={() => setMoveModalOpen(false)} />
                <MoveLeadModalTitle>{t("Move lead")}</MoveLeadModalTitle>
                  <Dropdown_ label={t("Selected quest")}>
                    <select
                      value={selectedQuest.id || ""}
                      onChange={(e) => handleSelectedQuest(e.target.value)}
                    >
                      {props.quests?.map((quest, i) => (
                        <option value={quest._id} key={i}>
                          {getQuestLabel(quest)}
                        </option>
                      ))}
                    </select>
                  </Dropdown_>
                <MoveLeadModalActions>
                  {selectedQuest?.id === props.editingLead?.landingId ? null :
                    <Main_
                      text={t("Move")}
                      onClick={() => {
                        setMoveModalOpen(false);
                        setMoreMenuOpen(false);
                        setConfirmMove(true);
                      }}
                    />
                  }
                </MoveLeadModalActions>
              </MoveLeadOptions>
            ) : (
              <>
                <Grey_ text={t('Move')} noPadding onClick={() => setMoveModalOpen(true)} />
                {props.editingLead.archivedAt ? null : <Grey_ text={t('Archive')} noPadding onClick={() => { setMoreMenuOpen(false); handleArchive(); }} />}
              </>
            )}
              </MoreActionsMenu>
            ) : null}
          </MoreActionsControl>
        </LeadActions>
    </LeadActionsWrapper>
  );

  const columnSelectContent = (  
        <CrmEditLead bg={props.columns?.[props.activeColumnId]?.color+33}>
           <Builder_ >   
             <Dropdown_ label={t('Column')}>
               <select
                  value={props.activeColumnId}
                  onChange={(e) => {
                    const newCol = e.target.value;
                    props.setActiveColumnId(newCol);
                    props.setEditingLead(prev => ({
                      ...prev,
                      pendingColumnId: newCol,
                    }));
                  }}
                >
                {props.columnOrder?.map((colId) => (
                  <option key={colId} value={colId}>
                    {props.columns[colId].title}
                  </option>
                ))}
              </select>
            </Dropdown_>
          </Builder_>
        </CrmEditLead>
  )
  const leftContent = (
  <>
    {!editingField ? (
      <FormBox filled onClick={() => setEditingField(true)}>
        <FormBoxTitle>
          <Filled_Edit />
          <h4>{t("Lead information")}</h4>
        </FormBoxTitle>

        {isDefined("FullName") && props.editingLead?.FullName ? (
          <CrmFormBoxSelection>
            <p>{props.editingLead.FullName}</p>
          </CrmFormBoxSelection>
        ): null}
        {isDefined("Name") && props.editingLead?.Name ? (
          <CrmFormBoxSelection>
            <p>{props.editingLead.Name}</p>
          </CrmFormBoxSelection>
        ): null}
        {isDefined("Surname") && props.editingLead?.Surname ? (
          <CrmFormBoxSelection>
            <p>{props.editingLead.Surname}</p>
          </CrmFormBoxSelection>
        ): null}
        {isDefined("Email") && props.editingLead?.Email ? (
          <CrmFormBoxSelection>
            <p>{props.editingLead.Email}</p>
          </CrmFormBoxSelection>
        ):null}

        {isDefined("Tel") && props.editingLead?.Tel?.length ? (
          <CrmFormBoxSelection> 
            <p>{props.editingLead.Tel}</p>
          </CrmFormBoxSelection>
        ): null}

        {customFieldRows.filter(f => String(f?.value ?? '').trim() !== '').map((fieldRow, i) => (
            <CrmFormBoxSelection key={i}>
              <h5>{fieldRow.key}</h5>
              <p>{fieldRow.value}</p>
            </CrmFormBoxSelection>
          ))}
      </FormBox>
    ) : (
      <EditFormBox>
        <EditFormBoxTitle>
          <h4>{t("Edit lead information")}</h4>
          <Main_ iconLeft="Check" onClick={() => setEditingField(false)} />
        </EditFormBoxTitle>

        {isDefined("FullName") && (
          <Builder_>
            <Input_
              placeholder={t("Full Name")}
              defaultValue={props.editingLead?.FullName}
              onChange={e =>
                updateLeadField("FullName", e.target.value)
              }
            />
          </Builder_>
        )}

        {isDefined("Name") && (
          <Builder_>
            <Input_
              placeholder={t("Name")}
              defaultValue={props.editingLead?.Name}
              onChange={e => updateLeadField("Name", e.target.value)}
            />
          </Builder_>
        )}

        {isDefined("Surname") && (
          <Builder_>
            <Input_
              placeholder={t("Surname")}
              defaultValue={props.editingLead?.Surname}
              onChange={e =>
                updateLeadField("Surname", e.target.value)
              }
            />
          </Builder_>
        )}

        {isDefined("Email") && (
          <Builder_>
            <Input_
              placeholder={t("Email")}
              defaultValue={props.editingLead?.Email}
              onChange={e => updateLeadField("Email", e.target.value)}
            />
          </Builder_>
        )}

        {isDefined("Tel") && (
          <Builder_>
            <Input_Phone
              placeholder={t("Phone number")}
              value={props.editingLead?.Tel || ""}
              onChange={(value) => updateLeadField("Tel", value)}
            />
          </Builder_>
        )}

        {props.isStandaloneBoard ? <LeadCustomFields fields={customFieldRows} error={customFieldError}
          onChange={fields => { props.setEditingLead({ ...props.editingLead, CustomField: fields });setCustomFieldError(''); }} />
          : customFieldRows.map((fieldRow, i) => (
            <Builder_ key={i}>
              <Input_
                placeholder={fieldRow.key}
                value={fieldRow.value ?? ''}
                onChange={e => {
                  updateCustomFieldRow(i, "value", e.target.value);
                }}
              />
            </Builder_>
          ))}
      </EditFormBox>
    )}

    <Builder_ title={isWon ? t('Enter the deal amount') : t('Enter the estimated deal amount')}>
      <Input_
          placeholder={t("Amount")}
          value={props.editingLead?.Amount || ''} 
          // 2. Use type="text" to stop browser number behavior
          type="text" 
          // 3. CRITICAL: This brings back the mobile number pad
          inputMode="decimal"   
          onChange={(e) => {
          const val = e.target.value;
            // 4. Regex: Allow only numbers and a single decimal point
            // This regex matches: Empty string OR digits optionally followed by one dot and more digits
            if (val === '' || /^\d*\.?\d*$/.test(val)) {
                updateLeadField('Amount', val);
            }
          }}
        />
    </Builder_>

  </>
);

  const scheduledCallDate = callFollowUp.status === "scheduled" && callFollowUp.scheduledAt
    ? new Date(callFollowUp.scheduledAt)
    : null;
  const hasValidScheduledCallDate = scheduledCallDate && !Number.isNaN(scheduledCallDate.getTime());
  const scheduledCallContext = hasValidScheduledCallDate ? (() => {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const callDay = new Date(scheduledCallDate.getFullYear(), scheduledCallDate.getMonth(), scheduledCallDate.getDate());
    const dayDifference = Math.round((callDay.getTime() - today.getTime()) / 86400000);
    const relativeDay = dayDifference === 0
      ? t("Today")
      : dayDifference === 1
        ? t("Tomorrow")
        : scheduledCallDate.toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });
    const calendarDay = scheduledCallDate.toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });
    return dayDifference === 0 || dayDifference === 1 ? `${relativeDay} · ${calendarDay}` : relativeDay;
  })() : "";

  const pastCallEvents = Array.isArray(callFollowUp.history)
    ? callFollowUp.history.filter((event) => ["completed", "cancelled"].includes(event.type))
    : [];

  const pastCallsContent = pastCallEvents.length ? (
    <FollowUpHistory>
      <Grey_Link
        text={`${t("Past calls")} (${pastCallEvents.length})`}
        noPadding
        onClick={() => setShowPastCalls((open) => !open)}
      />
      {showPastCalls ? [...pastCallEvents].reverse().map((event, index) => (
        <FollowUpHistoryRow key={`${event.at || index}-${event.type || "event"}`}>
          <div>
            <CallOutcome outcome={event.type === "cancelled" ? "cancelled" : event.outcome || "completed"}>
              <p>{t(event.type === "cancelled"
                ? "Cancelled"
                : CALL_OUTCOME_LABELS[event.outcome] || "Completed")}</p>
            </CallOutcome>
            <h6>{event.at ? new Date(event.at).toLocaleString() : ""}</h6>
            {event.note ? <p>{event.note}</p> : null}
          </div>
          <p>{event?.by?.name || event?.by?.email || ""}</p>
        </FollowUpHistoryRow>
      )) : null}
    </FollowUpHistory>
  ) : null;

  const callOutcomeContent = (
    <CallFollowUpBox>
      <FormBoxTitle>
        <h4>{t("How did the call go?")}</h4>
      </FormBoxTitle>
      <div>
        <OutcomeOptions>
          {Object.entries(CALL_OUTCOME_LABELS).map(([value, label]) => (
            <OutcomeOption
              key={value}
              type="button"
              selected={callOutcomeDraft.outcome === value}
              aria-pressed={callOutcomeDraft.outcome === value}
              onClick={() => selectCallOutcome(value)}
            >
              {t(label)}
            </OutcomeOption>
          ))}
        </OutcomeOptions>
      </div>
      <Builder_ title={t("Call note")}>
        <Textarea_
          value={callOutcomeDraft.note}
          placeholder={t("Add details from the call")}
          onChange={(event) => setCallOutcomeDraft((draft) => ({ ...draft, note: event.target.value }))}
          rows={3}
        />
      </Builder_>
      {callOutcomeDraft.outcome && callOutcomeDraft.outcome !== "wrong_number" ? (
        <ScheduleAnotherBox>
          <Checkbox_
            text={t("Schedule another call")}
            checked={callOutcomeDraft.scheduleAnother}
            onClick={() => setCallOutcomeDraft((draft) => {
              const scheduleAnother = !draft.scheduleAnother;
              return {
                ...draft,
                scheduleAnother,
                scheduledAt: scheduleAnother ? draft.scheduledAt || getSuggestedNextCallDate() : "",
              };
            })}
          />
        </ScheduleAnotherBox>
      ) : null}
      {callOutcomeDraft.scheduleAnother ? (
        <Builder_ title={useNativeDatePicker ? t("Call again") : undefined}>
          {useNativeDatePicker ? (
            <NativeDateTimeInput
              type="datetime-local"
              value={toDateTimeLocalValue(callOutcomeDraft.scheduledAt)}
              min={toDateTimeLocalValue(new Date())}
              onChange={(event) => {
                const date = event.target.value ? new Date(event.target.value) : null;
                setCallOutcomeDraft((draft) => ({ ...draft, scheduledAt: date ? date.toISOString() : "" }));
                setCallOutcomeError("");
              }}
            />
          ) : (
            <Calendar_Field
              label={t("Call again")}
              selected={callOutcomeDraft.scheduledAt ? new Date(callOutcomeDraft.scheduledAt) : null}
              defaultDate={callOutcomeDraft.scheduledAt ? new Date(callOutcomeDraft.scheduledAt) : null}
              onChange={(date) => {
                setCallOutcomeDraft((draft) => ({ ...draft, scheduledAt: date ? date.toISOString() : "" }));
                setCallOutcomeError("");
              }}
              placeholder={t("Choose date and time")}
              interval={15}
              minDate={new Date()}
            />
          )}
        </Builder_>
      ) : null}
      {callOutcomeError ? <CallFormError role="alert">{callOutcomeError}</CallFormError> : null}
      <CallFormFooter>
        <Main_
          text={t("Save result")}
          iconLeft="Check"
          disabled={savingCall}
          onClick={saveCallOutcome}
        />
        <Grey_Link
          text={t("Cancel")}
          iconLeft="Xicon"
          noPadding
          onClick={() => {
            setShowCallOutcomeForm(false);
            setCallOutcomeError("");
          }}
        />
      </CallFormFooter>
    </CallFollowUpBox>
  );

  const scheduleContent = showCallOutcomeForm ? callOutcomeContent : showCallScheduler ? (
      <CallFollowUpBox>
        <FormBoxTitle>
          <h4>{callFollowUp.status === "scheduled" ? t("Reschedule call") : t("Schedule call")}</h4>
        </FormBoxTitle>
        <Builder_ title={useNativeDatePicker ? t("Date and time") : undefined}>
          {useNativeDatePicker ? (
            <NativeDateTimeInput
              type="datetime-local"
              value={toDateTimeLocalValue(callDraft.scheduledAt)}
              min={toDateTimeLocalValue(new Date())}
              onChange={(event) => {
                const date = event.target.value ? new Date(event.target.value) : null;
                setCallDraft((draft) => ({ ...draft, scheduledAt: date ? date.toISOString() : "" }));
                setCallFormError("");
              }}
            />
          ) : (
            <Calendar_Field
              label={t("Date and time")}
              selected={callDraft.scheduledAt ? new Date(callDraft.scheduledAt) : null}
              defaultDate={callDraft.scheduledAt ? new Date(callDraft.scheduledAt) : null}
              onChange={(date) => {
                setCallDraft((draft) => ({ ...draft, scheduledAt: date ? date.toISOString() : "" }));
                setCallFormError("");
              }}
              placeholder={t("Choose date and time")}
              interval={15}
              minDate={new Date()}
            />
          )}
        </Builder_>
        {scheduleUsers.length > 1 ? <Builder_>
          <Dropdown_ label={t("Assigned to")}>
            <select
              value={callDraft?.assignedTo?.userId || callDraft?.assignedTo?.email || ""}
              onChange={(event) => {
                const assignee = scheduleUsers.find((user) => String(user?.userId || user?.id || user?.email || "") === event.target.value);
                setCallDraft((draft) => ({
                  ...draft,
                  assignedTo: assignee ? {
                    userId: assignee.userId || assignee.id || "",
                    email: assignee.email || "",
                    name: assignee.name || [assignee.firstname, assignee.lastname].filter(Boolean).join(" "),
                  } : null,
                }));
              }}
            >
              <option value="">{t("Assigned to me")}</option>
              {scheduleUsers.map((user) => {
                const value = String(user?.userId || user?.id || user?.email || "");
                const label = user?.name || [user?.firstname, user?.lastname].filter(Boolean).join(" ") || user?.email;
                return <option key={value} value={value}>{label}</option>;
              })}
            </select>
          </Dropdown_>
        </Builder_> : null}
        <Builder_ title={t("Agenda")}>
          <Textarea_
            value={callDraft.note || ""}
            placeholder={t("What should you discuss?")}
            onChange={(event) => setCallDraft((draft) => ({ ...draft, note: event.target.value }))}
            rows={3}
          />
        </Builder_>
        {callFormError ? <CallFormError role="alert">{callFormError}</CallFormError> : null}
        <CallFormFooter>
          <Main_
            text={t(callFollowUp.status === "scheduled" ? "Save changes" : "Schedule call")}
            iconLeft="Check"
            disabled={savingCall}
            onClick={scheduleCallFollowUp}
          />
          <Grey_Link
            text={t("Cancel")}
            iconLeft="Xicon"
            noPadding
            onClick={() => {
              setShowCallScheduler(false);
              setCallFormError("");
            }}
          />
        </CallFormFooter>
      </CallFollowUpBox>
    ) : callFollowUp.status === "scheduled" ? (
      <>
        <NextCallCard>
          <NextCallHeader>
            <h5>● {t("Next call")}</h5>
            {callFollowUp?.assignedTo?.name || callFollowUp?.assignedTo?.email ? (
              <p>{callFollowUp.assignedTo.name || callFollowUp.assignedTo.email}</p>
            ) : null}
          </NextCallHeader>
          <NextCallBody>
            <NextCallSchedule>
              {hasValidScheduledCallDate ? (
                <CallDateTile>
                  <span>{scheduledCallDate.toLocaleDateString(undefined, { month: "short" })}</span>
                  <strong>{scheduledCallDate.toLocaleDateString(undefined, { day: "2-digit" })}</strong>
                </CallDateTile>
              ) : null}
              <CallScheduleDetails>
                <h3>{hasValidScheduledCallDate
                  ? scheduledCallDate.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" })
                  : formatCallFollowUp(props.editingLead, t)}
                </h3>
                <p>{scheduledCallContext}</p>
                {props.editingLead?.Tel ? (
                  <a href={`tel:${String(props.editingLead.Tel).replace(/\s/g, "")}`}>
                    {props.editingLead.Tel}
                  </a>
                ) : null}
              </CallScheduleDetails>
              <CallFollowUpActions>
                {props.editingLead?.Tel ? (
                  <Main_
                    text={t("Call now")}
                    iconLeft="Phone"
                    size="small"
                    onClick={() => { window.location.href = `tel:${String(props.editingLead.Tel).replace(/\s/g, "")}`; }}
                  />
                ) : null}
                <Main_Plain
                  text={t("Finish call")}
                  iconLeft="Check"
                  noPadding
                  size="small"
                  disabled={savingCall}
                  onClick={openCallOutcomeForm}
                />
                <CallActionsControl ref={callActionsMenuRef}>
                  <Grey_
                    iconRight="More"
                    disabled={savingCall}
                    size="small"
                    aria-label={t("More call actions")}
                    onClick={() => setCallActionsMenuOpen((open) => !open)}
                  />
                  {callActionsMenuOpen ? (
                    <CallActionsMenu>
                      <Grey_
                        text={t("Edit call")}
                        noPadding
                        size="small"
                        onClick={openCallScheduler}
                      />
                      <Red_
                        text={t("Cancel call")}
                        // noPadding
                        onClick={() => {
                          setCallActionsMenuOpen(false);
                          cancelCallFollowUp();
                        }}
                      />
                    </CallActionsMenu>
                  ) : null}
                </CallActionsControl>
              </CallFollowUpActions>
            </NextCallSchedule>
            {callFollowUp.note ? (
              <CallAgenda>
                <h6>{t("Agenda")}</h6>
                <p>{callFollowUp.note}</p>
              </CallAgenda>
            ) : null}
          </NextCallBody>
        </NextCallCard>
        {pastCallsContent}
      </>
    ) : callFollowUp.status === "completed" ? (
      <>
        <CompletedCallSummary filled>
          <div>
            <h4>{t(CALL_OUTCOME_LABELS[callFollowUp.outcome] || "Call completed")}</h4>
            <p>
              {callFollowUp.completedAt
                ? new Date(callFollowUp.completedAt).toLocaleString()
                : ""}
            </p>
            {callFollowUp.outcomeNote ? <p>{callFollowUp.outcomeNote}</p> : null}
          </div>
          <Main_Plain
            text={t("Schedule another call")}
            iconLeft="Calendar"
            noPadding
            onClick={openCallScheduler}
          />
        </CompletedCallSummary>
        {pastCallsContent}
      </>
    ) : (
      <>
        <CallFollowUpSummary filled onClick={openCallScheduler}>
          <div>
            <h4>{t("No upcoming call")}</h4>
            <p>{t("Schedule a call when this lead needs your attention.")}</p>
          </div>
          <Main_Plain text={t("Schedule call")} iconLeft="Calendar" noPadding onClick={openCallScheduler} />
        </CallFollowUpSummary>
        {pastCallsContent}
      </>
    );


  const notesContent = (
    <Crm_Lead_Notes
      notes={localNotes}
      setNotes={updateNotesState}
      currentUserId={currentUserId}
      currentUserName={currentUserName}
      currentUserEmail={currentUserEmail}
      leadId={props.editingLead?._id}
      handleAdd={handleAddNote}
      text={text}
      setText={setText}   
      mode="edit"   
    />
  );

  const handleSave = () => {
    const error = props.isStandaloneBoard ? getLeadCustomFieldsError(customFieldRows, t) : '';
    setCustomFieldError(error);
    if (error) { setActiveTab('details');setEditingField(true);return; }
    const leadWithNotes = {
      ...props.editingLead,
      ...(props.isStandaloneBoard ? { CustomField: leadCustomFieldPayload(customFieldRows) } : {}),
      Notes: localNotesRef.current,
    };

    props.setEditingLead(leadWithNotes);
    props.onLeadPatched?.(leadWithNotes);
    props.saveLead(leadWithNotes);
  };

  console.log('editing lead', props.editingLead.Notes, localNotes);
  
  return (

<>
  {confirmMove ? 
    <Confirmation_
        message={t("Are you sure you want to move")+' '+name+' '+'to'+' '+getQuestLabel(selectedQuest?.data) }
        no= {t('Cancel')}
        onNo={() => setConfirmMove(false) }
        onYes={()=> moveLead()}
        yes={("Yes")}
      /> 
  :null}
    <Lead_Editor_Layout
      title={t("Edit") + " " + name}
      onSave={handleSave}
      archivedLabel={props.editingLead?.archivedAt ? archivedLabel : null}
      activeTab={activeTab}
      notesOnRight
      headerActions={headerActions}
      columnSelectContent={columnSelectContent}
      leftContent={leftContent}
      notesContent={notesContent}
      scheduleContent={scheduleContent}
      
    />
  </>
  )
}
 
